var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "device-row" }, [
    _c("div", { staticStyle: { flex: "1" } }, [
      _vm._v("\n    " + _vm._s(_vm.auth.mac_address) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { flex: "1 1 10%", "word-break": "break-word" } },
      [_vm._v("\n    " + _vm._s(_vm.auth.name) + "\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticStyle: { flex: "1", "word-break": "break-word" } }, [
      _vm._v("\n    " + _vm._s(_vm.auth.product.description) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.hidden, staticStyle: { flex: "1", "text-align": "right" } },
      [
        _c("el-tag", [_vm._v(_vm._s(_vm._f("capitalize")(_vm.auth.role)))]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "acl",
                rawName: "v-acl.show",
                value: { permission: "manageSharedUser", on: "Device" },
                expression: "{permission: 'manageSharedUser', on: 'Device'}",
                modifiers: { show: true },
              },
            ],
            staticStyle: { "margin-left": "5px", color: "white" },
          },
          [
            !_vm.granted
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.auth.role === "owner",
                      type: "primary",
                      loading: _vm.loading,
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addUserToLocation(_vm.auth)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      staticStyle: { color: "white" },
                    }),
                  ]
                )
              : _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.auth.role === "owner",
                      type: "danger",
                      loading: _vm.loading,
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeUserFromLocation(_vm.auth)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-minus",
                      staticStyle: { color: "white" },
                    }),
                  ]
                ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }